<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户id">
              <a-input placeholder="请输入用户id" v-model="queryParam.userId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="真实姓名">
              <a-input placeholder="请输入真实姓名" v-model="queryParam.realName"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="证件类型(1港澳居民来往内地通行证 2台湾居民来往内地通行证 3外国人永久居留证 4中国大陆身份证)">
              <a-input placeholder="请输入证件类型(1港澳居民来往内地通行证 2台湾居民来往内地通行证 3外国人永久居留证 4中国大陆身份证)" v-model="queryParam.documentType"></a-input>
            </a-form-item>
          </a-col> -->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="证件号码">
                <a-input placeholder="请输入证件号码" v-model="queryParam.documentNumber"></a-input>
              </a-form-item>
            </a-col>
            <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="证件照（人像面）">
              <a-input placeholder="请输入证件照（人像面）" v-model="queryParam.documentPhotoFront"></a-input>
            </a-form-item>
          </a-col> -->
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('签约作者审核')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div> -->

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->
      <!--      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" -->
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->

          <a-popconfirm
            v-if="record.status == 1"
            title="你确定通过该用户的作者审核吗？"
            ok-text="Yes"
            cancel-text="No"
            @confirm="passConfirm(record)"
          >
            <a style="margin-right: 10px">通过</a>
          </a-popconfirm>
          <a v-if="record.status == 1" @click="noPass(record)">不通过</a>
        
        </span>
        <span slot="status" slot-scope="text, record">
          {{ statusMenu[text] }}
        </span>
        <span slot="documentType" slot-scope="text, record">
          {{ documentTypeMenu[text] }}
        </span>
        <span slot="documentPhotoFront" slot-scope="text, record">
          <a @click="checkDetail(text)">详情</a>
        </span>
        <span slot="documentPhotoBack" slot-scope="text, record">
          <a @click="checkDetail(text)">详情</a>
        </span>
        <span slot="documentPhotoHand" slot-scope="text, record">
          <a @click="checkDetail(text)">详情</a>
        </span>
      </a-table>

      <a-modal title="不通过原因" :visible="visible" @ok="noPassConfirm" @cancel="handleCancel">
        <a-input placeholder="请输入不通过原因 " v-model="reason" />
      </a-modal>
      <a-modal title="详情" :visible="detailsVisible" @ok="handleCancel" @cancel="handleCancel">
        <img
          width="100%"
          :src="window._CONFIG['resourceURL'] + '/school/sys/common/downloadSlice?filename=' + detailsUrl.split(',')[0]"
          alt=""
        />
      </a-modal>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <articleAuthorVerification-modal ref="modalForm" @ok="modalFormOk"></articleAuthorVerification-modal>
  </a-card>
</template>

<script>
import { httpAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import ArticleAuthorVerificationModal from './modules/ArticleAuthorVerificationModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'ArticleAuthorVerificationList',
  mixins: [JeecgListMixin],
  components: {
    ArticleAuthorVerificationModal,
  },
  data() {
    return {
      selectRecord: {},
      showPreview: false,
      detailsVisible: false,
      visible: false,
      reason: '',
      description: '签约作者审核管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '用户id',
          align: 'center',
          dataIndex: 'userId',
        },
        {
          title: '真实姓名',
          align: 'center',
          dataIndex: 'realName',
        },
        // (1港澳居民来往内地通行证 2台湾居民来往内地通行证 3外国人永久居留证 4中国大陆身份证)
        {
          title: '证件类型',
          align: 'center',
          dataIndex: 'documentType',
          scopedSlots: { customRender: 'documentType' },
        },
        {
          title: '证件号码',
          align: 'center',
          dataIndex: 'documentNumber',
        },
        {
          title: '证件照（人像面）',
          align: 'center',
          dataIndex: 'documentPhotoFront',
          scopedSlots: { customRender: 'documentPhotoFront' },
        },
        {
          title: '证件照（国徽面）',
          align: 'center',
          dataIndex: 'documentPhotoBack',
          scopedSlots: { customRender: 'documentPhotoBack' },
        },
        {
          title: '手持证件照',
          align: 'center',
          dataIndex: 'documentPhotoHand',
          scopedSlots: { customRender: 'documentPhotoHand' },
        },
        //  1审核中 2通过 3未通过
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      statusMenu: {
        1: '审核中',
        2: '通过',
        3: '未通过',
      },
      documentTypeMenu: {
        // 1港澳居民来往内地通行证 2台湾居民来往内地通行证 3外国人永久居留证 4中国大陆身份证
        1: '港澳居民来往内地通行证',
        2: '台湾居民来往内地通行证',
        3: '外国人永久居留证',
        4: '中国大陆身份证',
      },

      url: {
        list: '/aigoes/articleAuthorVerification/list',
        delete: '/aigoes/articleAuthorVerification/delete',
        deleteBatch: '/aigoes/articleAuthorVerification/deleteBatch',
        exportXlsUrl: '/aigoes/articleAuthorVerification/exportXls',
        importExcelUrl: '/aigoes/articleAuthorVerification/importExcel',
      },
      detailsUrl: '',
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.detailsVisible = false
    },
    checkDetail(text) {
      this.detailsUrl = text
      this.detailsVisible = true
    },
    passConfirm(record) {
      console.log(record)

      httpAction(
        '/aigoes/articleAuthorVerification/becomeAuthor',
        {
          userId: record.userId,
          id: record.id,
          status: 2,
        },
        'post'
      )
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('ok')
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loadData()
          // this.confirmLoading = false
          // this.close()
        })
    },
    noPass(record) {
      this.visible = true
      this.selectRecord = record
    },
    noPassConfirm() {
      if (this.reason.length == '0') {
        return this.$message.warning('请输入不通过原因')
      } else {
        httpAction(
          '/aigoes/articleAuthorVerification/becomeAuthor',
          {
            userId: this.selectRecord.userId,
            id: this.selectRecord.id,
            status: 3,
            reason: this.reason,
          },
          'post'
        )
          .then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.$emit('ok')
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loadData()
            // this.confirmLoading = false
            // this.close()
          })
      }
      this.visible = false
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
